import { render, staticRenderFns } from "./ThirdPartySourcesTable.vue?vue&type=template&id=bc193f1c&"
import script from "./ThirdPartySourcesTable.vue?vue&type=script&lang=js&"
export * from "./ThirdPartySourcesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports